import { BankStatementsConstants } from 'constants/bankStatementsConstants';
import { createAction } from 'redux-actions';

export const setDataVersionAction = createAction(BankStatementsConstants.SET_DATA_VERSION);
export const getStatementsAction = createAction(BankStatementsConstants.GET_STATEMENTS);
export const processStatementAction = createAction(BankStatementsConstants.PROCESS_STATEMENT);
